import React, { Component } from "react";
import axios from "axios";
import styles from "./styles/AcceptEmployer.scss";
import Loader from "../../Loader/Loader";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAddressCard, faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";


export default class AcceptEmployer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: undefined,
    };
  }

  async componentDidMount() {
    // Make call to database using ID from URL
    let id = this.props.location.search.substring(1);
    console.log("ID:", id)
    await axios
      .post("/api/kingstonconnect/verifyemployer/", {"_id": id})
      .then(res => {
        this.setState({
          loading: false
        })
      })
      .catch(e => {
        this.setState({
          loading: false,
          error: true
        })
      })
  }

  render() {
    if (this.state.error){
      return (
        <div className={styles.page}>
          <h5>This link is invalid.</h5>
        </div>
      )
    } else if (this.state.loading){
      return ( <Loader /> )
    } else {
    return (
      <div className={styles.page}>
        <h1>You've validated your email!</h1>
        <p>You must wait for administrative approval to login to your account.</p>
        <p>You will recieve an email when this is completed.</p>
    </div>
  )}}
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/AcceptEmployer.js